import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { deletePendingOrderAndRelated } from "~/providers/api/patientProfileService";

interface DeleteOrderAndRelatedParams {
  patientId: string;
  orderId?: string;
  onSuccess: () => void;
}

export const useDeleteOrderAndRelated = ({
  patientId,
  orderId,
  onSuccess,
}: DeleteOrderAndRelatedParams) => {
  const queryClient = useQueryClient();

  const { mutate: deleteOrderAndRelatedMutation, isPending } = useMutation({
    mutationFn: () => deletePendingOrderAndRelated(patientId, orderId ?? ""),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["getPendingPatientInteractions"],
      });
      onSuccess();
    },
    onError: () =>
      toast.error("We had trouble deleting this order, try again later."),
  });

  return {
    deleteOrderAndRelatedMutation,
    isPending,
  };
};
